/**
 * COMPONENT: MainGuestSelectorPopup.jsx
 * Selección de cliente como Main Guest (mismo estilo que CustomerSelectorPopup para Booker).
 */

import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

const MainGuestSelectorPopup = ({ show, onClose, reservationId, onCustomerSelected }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (show) fetchCustomers();
  }, [show]);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/customers");
      setCustomers(res.data || []);
    } catch (err) {
      console.error("[MainGuestSelectorPopup] ❌ Error fetching customers:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async (customerId) => {
    try {
      if (!reservationId) {
        alert("Reservation ID not provided.");
        return;
      }

      // 1. POST → insertar main guest en reservation_guests
      await axios.post(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-guests`, {
        reservation_draft_id: reservationId,
        customer_id: customerId,
        is_main_guest: true,
        is_child: false,
        relationship: null,
        guest_index: null
      });



      // 2. traer los datos completos del customer
      const { data: customer } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/customers/${customerId}`
      );

      // 3. notificar al padre con el objeto completo
      if (onCustomerSelected) onCustomerSelected(customer);

      onClose(); // cerrar popup
    } catch (err) {
      console.error("[MainGuestSelectorPopup] ❌ Error assigning main guest:", err);
      alert("Failed to assign main guest.");
    }
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1050,
      }}
    >
      <div style={{ zoom: 0.9, width: "900px", maxWidth: "95%" }}>
        <div
          style={{
            backgroundColor: "#1a1a1a",
            color: "white",
            padding: "20px",
            borderRadius: "6px",
          }}
        >
          <h2 className="text-warning text-center mb-3">Select Main Guest</h2>

          {loading ? (
            <p className="text-light">Loading customers…</p>
          ) : (
            <div className="table-responsive" style={{ maxHeight: "60vh", overflowY: "auto" }}>
              <table style={{ tableLayout: "fixed", width: "100%" }}>
                <thead className="sticky-top bg-warning text-dark">
                  <tr>
                    {["Name", "Email", "Country", "Actions"].map((header, i) => (
                      <th
                        key={i}
                        style={{
                          minWidth:
                            header === "Name" ? "160px" :
                            header === "Email" ? "220px" :
                            header === "Country" ? "100px" : "80px",
                          maxWidth:
                            header === "Email" ? "220px" :
                            header === "Name" ? "180px" :
                            "120px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontSize: "0.85rem",
                        }}
                        title={header}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {customers.length > 0 ? (
                    customers.map((c) => (
                      <tr key={c.id}>
                        <td
                          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                          title={`${c.first_name || ""} ${c.last_name || ""}`}
                        >
                          {c.first_name} {c.last_name}
                        </td>
                        <td
                          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                          title={c.email || ""}
                        >
                          {c.email || "—"}
                        </td>
                        <td>{c.country || "—"}</td>
                        <td>
                          <button
                            onClick={() => handleSelect(c.id)}
                            style={{
                              background: "linear-gradient(to right, #1abc9c, #3498db)",
                              border: "none",
                              borderRadius: "4px",
                              color: "white",
                              fontSize: "0.7rem",
                              fontWeight: "bold",
                              padding: "2px 8px",
                              cursor: "pointer",
                            }}
                          >
                            Select
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-3 text-light">
                        No customers found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-end mt-3">
            <button
              onClick={onClose}
              style={{
                background: "linear-gradient(to right, #9b59b6, #8e44ad)",
                border: "none",
                borderRadius: "4px",
                color: "white",
                fontSize: "0.8rem",
                fontWeight: "bold",
                padding: "6px 14px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainGuestSelectorPopup;
